document.addEventListener('DOMContentLoaded', function () {

    // Play cta: hide poster display video onclick
    document.querySelectorAll('.play').forEach(function (el) {
        el.addEventListener('click', function () {
            var video = this.parentElement.parentElement.querySelector('.video');
            if (video) video.classList.remove('hide');
            this.closest('.poster').classList.add('hide');
        });
    });

    // Readmore cta
    var readmoreBtn = document.getElementById('readmore');
    if (readmoreBtn) {
        readmoreBtn.addEventListener('click', function () {
            var showmore = document.getElementById('showmore');
            if (this.innerHTML === 'Read more') {
                this.innerHTML = 'Read less';
                if (showmore) showmore.classList.remove('hide');
            } else {
                this.innerHTML = 'Read more';
                if (showmore) showmore.classList.add('hide');
            }
        });
    }

    // Copy to clipboard
    document.querySelectorAll('.to-clipboard').forEach(function (el) {
        el.addEventListener('click', function () {
            var url = window.location.href;
            if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(url).then(function () {
                    var copied = document.getElementById('copied_url');
                    if (copied) copied.classList.remove('vis-hidden');
                });
            }
        });
    });

    // Press materials column count
    function updatePressMaterialsColumns() {
        var list = document.getElementById('press-materials');
        if (!list) return;
        var numItems = list.querySelectorAll('li').length;
        if (window.innerWidth < 1400) {
            list.style.columnCount = 2;
        } else {
            list.style.columnCount = Math.round(numItems / 2);
        }
    }
    window.addEventListener('resize', updatePressMaterialsColumns);
    updatePressMaterialsColumns();

});
